





































import { Component, Emit, PropSync, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component
export default class MultiSelect extends Vue {
  @PropSync('isShow', { type: Boolean }) syncedIsShow!: boolean;
  @PropSync('itemList', { type: Array }) syncedItemList!: any;
  @PropSync('chkList', { type: Array }) syncedChkList!: any;

  @Prop({ type: Array, default: () => [] }) allInventoryColumns?: Array<string>;

  @Action('updateQueryParams', { namespace: 'inventory' }) c_updateInventoryQueryParams!: any;

  public isIndeterminate: boolean = true;
  public checkAll: boolean = true;

  async mounted() {
    await this.anyWhereClose();
  }

  setColumn() {
    this.syncedIsShow ? (this.syncedIsShow = false) : (this.syncedIsShow = true);
  }

  @Emit('emitCurrentStatuses')
  @Emit('emitCurrentColumns')
  currentStatuses(value: any) {
    const name = this.$route.name;

    let checkedCount = value.length;
    this.checkAll = checkedCount === this.syncedItemList.length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.syncedItemList.length;

    if (name === 'ContentView') {
      const result = this.allInventoryColumns!.map((column: string) => {
        let match = false;
        this.syncedChkList.forEach((val: string) => {
          if (val === column) match = true;
        });
        if (match) return column;
      }).filter((colunm: any) => colunm !== undefined);

      this.syncedChkList = [...result];
    } else return this.syncedChkList;
  }

  @Emit('emitCurrentStatuses')
  @Emit('emitCurrentColumns')
  handleCheckAllChange(value: any) {
    const name = this.$route.name;

    this.isIndeterminate = false;

    if (name === 'ContentView') {
      this.syncedChkList = value ? this.allInventoryColumns : [];
    } else {
      return value ? this.syncedItemList.map((item: any) => item.value) : [];
    }
  }

  anyWhereClose() {
    document.addEventListener('click', (e: any) => {
      if ((this.$refs.layerSet as HTMLElement) !== undefined) {
        if (
          !e.target.dataset.hasOwnProperty('colSet') &&
          !(this.$refs.layerSet as HTMLElement).contains(e.target)
        ) {
          this.syncedIsShow = false;
        }
      }
    });
  }
}
